export default "__VITE_ASSET__CaXtVRn2__"